module.exports = __webpack_public_path__ + "img/Play.5beafa71.png";